import { useState } from 'react';
import { Languages } from 'lucide-react';
import { cn } from '@/lib/utils';

const PWA_ICON_URL = "https://mwagobcotsnleuttbvau.supabase.co/storage/v1/object/public/pwa-icons/pwa-192x192.png";
const LOGO_WEBP_URL = "/logo-80.webp";

interface LogoIconProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

const iconSizes = {
  sm: 'w-5 h-5',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

export function LogoIcon({ size = 'sm', className }: LogoIconProps) {
  const [logoError, setLogoError] = useState(false);

  if (logoError) {
    return (
      <div className={cn(sizeClasses[size], 'rounded-lg gradient-primary flex items-center justify-center', className)}>
        <Languages className={cn(iconSizes[size], 'text-primary-foreground')} />
      </div>
    );
  }

  const w = size === 'lg' ? 48 : size === 'md' ? 40 : 32;
  const h = w;

  return (
    <picture>
      <source srcSet={LOGO_WEBP_URL} type="image/webp" />
      <img 
        src={PWA_ICON_URL}
        alt="Leka - Language Learning App Logo"
        className={cn(sizeClasses[size], 'rounded-lg', className)}
        onError={() => setLogoError(true)}
        loading="eager"
        fetchPriority="high"
        width={w}
        height={h}
      />
    </picture>
  );
}
